import React from 'react';
import { ButtonColor, ButtonSize, IButtonProps } from './ButtonInterface';

// Define a type for button colors and sizes to enforce valid values




// Utility function to get the CSS classes based on color
const getColorClasses = (color: ButtonColor): string => {
    switch (color) {
        case 'primary':
            return 'text-white';
        case 'secondary':
            return 'text-black';
        default:
            throw new Error(`Unsupported button color: ${color}`);
    }
};

// Utility function to get the CSS classes based on size
const getSizeClasses = (size: ButtonSize): string => {
    switch (size) {
        case 'small':
            return 'px-8 py-4 text-sm';
        case 'medium':
            return 'px-16 py-8 text-base';
        case 'large':
            return 'px-24 py-12 text-lg';
        default:
            throw new Error(`Unsupported button size: ${size}`);
    }
};

// Button component implementing the IButtonProps interface
const Button: React.FC<IButtonProps> = ({ text, color, size, onClick }) => {
    try {
        const colorClasses = getColorClasses(color);
        const sizeClasses = getSizeClasses(size);

        return (
            <button
                className={`bg-supernova rounded-full font-bold border hover:text-white hover:bg-yellowBrown ${colorClasses} ${sizeClasses}`}
                onClick={onClick}
            >
                {text}
            </button>
        );
    } catch (error) {
        console.error(error);
        return null; // In case of error, return null to avoid rendering a broken button
    }
};

export default Button;
